module.exports = __webpack_public_path__ + "static/news-turkey-82f3a12762246371929048227f7fd39d.svg";